import { CommonModule } from '@angular/common';
import { Input, NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
// import { HeaderComponent } from '../component/header/header.component';
import { InvalidMessageDirective } from '../directive/invalidmessage.directive';
import { InvalidTypeDirective } from '../directive/invalidtype.directive';
import { ImageUploadComponent } from '../component/image-upload/image-upload.component';
import { HttpService } from '../service/http.service';
import { FacebookModule } from 'ngx-facebook';
import { SignupFormComponent } from '../component/signup-form/signup-form.component';
import { LoadingComponent } from '../component/loading/loading.component';
import { CustomMessageComponent } from '../component/custom-message/custom-message.component';
import { FeedService } from '../service/feed.service';
import { ElememtDirective } from '../directive/elememt.directive';
import { ImageCropperComponent } from "ng2-img-cropper-mm420";
import { AddressFormatePipe } from '../pipe/address-formate.pipe';
import { TruncatePipe } from '../pipe/truncate.pipe';
import { ProtectedNamePipe } from '../pipe/protected-name.pipe';
import { MaskedPrivateMessagesNamePipe } from '../pipe/masked-private-messages-name';

@NgModule({
    declarations: [
        // HeaderComponent,
        InvalidMessageDirective,
        InvalidTypeDirective,
        ImageUploadComponent,
        SignupFormComponent,
        ElememtDirective,
        ImageCropperComponent,
        AddressFormatePipe,
        TruncatePipe,
        ProtectedNamePipe,
        MaskedPrivateMessagesNamePipe,
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        FacebookModule.forRoot()

    ],
    exports: [
        CommonModule,
        FacebookModule,
        ReactiveFormsModule,
        FormsModule,
        // HeaderComponent,
        InvalidTypeDirective,
        InvalidMessageDirective,
        ImageUploadComponent,
        SignupFormComponent,
        ElememtDirective,
        ProtectedNamePipe,
        MaskedPrivateMessagesNamePipe

    ],
    providers: [HttpService, FeedService]
})
export class SharedModule {
    @Input() properties: any;
    @Input() expandable: boolean;
    @Input() textEnabled: boolean;
    @Input() platforms: string[];
}
